import { isNil } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import { withScreenContext } from "../../components/screen/ScreenContext";
import { isScreenModeMobile } from "../../constants/screenModes";
import { appStateOperations, appStateSelectors } from "../../modules/appState";
import { chooseValueForHarvard, mergeDispatchToProps } from "../../utils/codeSplit";
import FilterPanel from ".";

const MAX_FILTER_ROWS = 3;

const getRowAddButton = chooseValueForHarvard((onAddView, prevViewId) => {
  return (
    <div className={`filterGroupAddViewButton`}>
      <FormButton label="Add Another View" secondary={true} onClick={() => onAddView(prevViewId)} />
    </div>
  );
}, null);

const FilterGroupPanel = props => {
  const panelStyles = {
    position: "relative"
  };

  const getNormalPanels = () => {
    return Array(Math.min(MAX_FILTER_ROWS, props.openViewIds.size + 1))
      .fill("")
      .map((_v, index) => {
        const viewId = props.openViewIds.get(index);
        const prevViewId = props.openViewIds.get(index - 1);
        const panelHeight = "auto";
        // viewId
        //   ? `calc(${100 / (viewsCount || 1)}% - ${(MAX_FILTER_ROWS - viewsCount) * filterHeaderHeight}px)`
        //   : "auto";
        const wrapperStyles = { height: panelHeight };
        return (
          <div key={index} className="filterGroupPanelWrapper" style={wrapperStyles}>
            {
              // If view id not available
              // means it is not showing, should split the previous view
            }
            {viewId ? (
              <FilterPanel
                assignedFilterId={viewId}
                style={panelStyles}
                hideHeader={true}
                showRowHeader={true}
                rowViewId={viewId}
                rowOnRemove={props.onRemoveView}
                rowIndex={index}
                addButtonLabel={"More Filters"}
                openViewIds={props.openViewIds}
              />
            ) : null}
            {isNil(viewId) && prevViewId ? getRowAddButton(props.onAddView, prevViewId) : null}
          </div>
        );
      });
  };

  const getMobilePanels = () => {
    return (
      <div className="filterGroupPanelWrapper">
        {<FilterPanel assignedFilterId={props.mobileViewType} style={panelStyles} hideHeader={true} />}
      </div>
    );
  };

  return (
    <div className="filterGroupPanel">
      <div key="header" className="filterGroupPanelHeader">
        <span>Filter Events</span>
      </div>
      {isScreenModeMobile(props.screenContext.screenMode) ? getMobilePanels() : getNormalPanels()}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    openViewIds: appStateSelectors.getOpenViewIds(state.present),
    activeViewId: appStateSelectors.getActiveViewId(state.present),
    //#!if harvard === true
    mobileViewType: appStateSelectors.getMobilePortraitViewType(state.present)
    //#!endif
  };
};

const readonlyActions = {
  onAddView: appStateOperations.splitViewHorizontal,
  onRemoveView: appStateOperations.removeView
};

const editingActions = {};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

FilterGroupPanel.propTypes = {
  openViewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  activeViewId: PropTypes.string.isRequired,
  onAddView: PropTypes.func,
  onRemoveView: PropTypes.func,

  //#!if harvard === true
  mobileViewType: PropTypes.string,
  //#!endif

  // From withScreenContext
  screenContext: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(withScreenContext(FilterGroupPanel));
